import Grid from '@material-ui/core/Grid';
import React, { FC } from 'react';
import { ILoginUser } from './interfaces/dtos/ILoginUser';
import { ILoginUserErrors } from './interfaces/dtos/ILoginUserErrors';
import LoginForm from './login-form';
import { useStyles } from './user-login-styles';

const UserLogin: FC<IUserLoginProps> = ({
  errors,
  user,
  setLogin,
  onLogin,
  onChange,
}): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container className={classes.gridcontaineruser}>
      <LoginForm
        errors={errors}
        user={user}
        setLogin={setLogin}
        onLogin={onLogin}
        onChange={onChange}
      />
    </Grid>
  );
};

interface IUserLoginProps {
  setLogin: (state: ILoginUser) => void;
  user: ILoginUser;
  errors: ILoginUserErrors;
  onLogin: (event: React.FormEvent<HTMLFormElement>) => void;
  onChange: (name: string, value: string) => void;
}

export default UserLogin;
